/*
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-07-10 21:28:48
 * @LastEditTime: 2019-11-18 22:48:29
 * @LastEditors: Please set LastEditors
 */
export const UCNavBarEvent=
{   
    /**
     * 切换线路
     */
    ucNavBar_switch_routeLine:"event_ucNavBar_switch_routeLine",

    /**
     * 测量距离
     */
    ucNavBar_tool_measureDistance:"event_ucNavBar_tool_measureDistance",

    /**
     * 测量面积
     */
    ucNavBar_tool_measureArea:"event_ucNavBar_tool_measureArea",

    /**
     * 用户收藏
     */
    ucNavBar_tool_userCollect:"event_ucNavBar_tool_userCollect",
    
    /**
     * 标点
     */
    ucNavBar_tool_drawPoint:"event_ucNavBar_tool_drawPoint",

    /**
     * 标线
     */
    ucNavBar_tool_drawPolyline:"event_ucNavBar_tool_drawPolyline",

    /**
     * 标面
     */
    ucNavBar_tool_drawPolygon:"event_ucNavBar_tool_drawPolygon",


    /**
     * 清空
     */
    ucNavBar_tool_clear:"event_ucNavBar_tool_clear",
    
    /**
     *全屏
     */
    ucNavBar_tool_fullscreen:"event_ucNavBar_tool_fullscreen",

}

export const UCFormUserVerifyEvent=
{
    /**
     * 用户验证成功
     */
    UCFormUserVerify_event_verifySucceed:"UCFormUserVerify_event_verifySucceed",

}